function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6105 28C17.931 25.6795 17.931 21.9005 15.6105 19.5469L7.82045 11.79L4.27348 15.337C3.90884 15.7016 3.90884 16.2983 4.27348 16.6961L15.6105 28Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9473 15.337L15.6105 4L15.5773 4.03315C13.2569 6.35359 13.2901 10.1326 15.6105 12.453L23.4004 20.2099L26.9473 16.663C27.312 16.2983 27.312 15.7016 26.9473 15.337Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6105 12.4531C13.2901 10.1326 13.2901 6.35364 15.5774 4.0332L7.48901 12.1216L11.699 16.3315L15.6105 12.4531Z",
  fill: "url(#paint0_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4888 15.6685L15.6104 19.5469C17.9308 21.8673 17.9308 25.6463 15.6104 27.9999L23.6988 19.9115L19.4888 15.6685Z",
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 15.4374,
  y1: 8.41486,
  x2: 10.5381,
  y2: 13.3141,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0680226,
  stopColor: "white",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 15.9346,
  y1: 23.4582,
  x2: 21.2996,
  y2: 18.0931,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0680226,
  stopColor: "white",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9077,
  stopColor: "white"
})));

var SvgJiraIcon = function SvgJiraIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJiraIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jira-icon.7194acb4.svg";
export { ForwardRef as ReactComponent };